<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <div class="row" style="text-align: center">
    <div class="col-md-12">
      <br />
      <div>
        <button @click="redirect()" class="btn btn-primary btn-lg" style="font-size: 17px">Voltar</button>
      </div>
      <br />
    </div>
  </div>

  <!-- DADOS PF -->
  <div class="row">
    <div class="col-md-12">
      <div class="card card-primary">
        <div class="card-header">
          <h3 v-if="!magistrado" class="card-title" style="color: white">Cadastro de pessoa física</h3>
          <h3 v-else class="card-title" style="color: white">Cadastro de pessoa física (magistrado)</h3>
        </div>

        <div class="card-body">
          <div class="row">
            <!-- NOME COMPLETO -->
            <div class="col-sm-9">
              <div class="form-group">
                <label for="exampleInputEmail1">Nome completo</label>
                <input style="text-transform: uppercase" class="form-control" id="nome_completo" v-model="formData.nome_completo" />

                <span style="color: red" v-for="error in v$.nome_completo.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- CPF -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="cpf">CPF</label>

                <InputMask
                  @blur="validateCPF"
                  id="basic"
                  class="form-control"
                  v-model="formData.cpf"
                  placeholder="___.___.___-__"
                  mask="999.999.999-99"
                />

                <span style="color: red" v-for="error in errors.cpf" :key="error">
                  {{ error }}
                </span>

                <span style="color: red" v-for="error in v$.cpf.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- RG -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="cpf">RG</label>
                <input class="form-control" id="cpf" v-model="formData.rg" style="text-transform: uppercase" />

                <span style="color: red" v-for="error in v$.rg.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ORGÃO EXPEDIDOR -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="orgao_expedidor">Orgão expedidor</label>

                <input class="form-control" id="orgao_expedidor" v-model="formData.orgao_expedidor" style="text-transform: uppercase" />

                <span style="color: red" v-for="error in v$.orgao_expedidor.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- DATA EMISSÃO RG -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="data_emissao_rg">Data emissão RG</label>

                <InputMask
                  id="basic"
                  class="form-control"
                  v-model="formData.data_emissao_rg"
                  placeholder="__/__/____"
                  mask="99/99/9999"
                  slotChar="__/__/____"
                />

                <span style="color: red" v-for="error in v$.data_emissao_rg.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- DATA NASCIMENTO-->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="data_emissao_rg">Data de nascimento</label>

                <InputMask
                  id="basic"
                  class="form-control"
                  v-model="formData.data_nascimento"
                  placeholder="__/__/____"
                  mask="99/99/9999"
                  slotChar="__/__/____"
                />

                <span style="color: red" v-for="error in v$.data_nascimento.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- NACIONALIDADE -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="nacionalidade">Nacionalidade</label>

                <input style="text-transform: uppercase" class="form-control" id="nacionalidade" v-model="formData.nacionalidade" />

                <span style="color: red" v-for="error in v$.nacionalidade.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- NATURALIDADE -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="naturalidade">Naturalidade (Cidade/Estado)</label>

                <input style="text-transform: uppercase" type="text" class="form-control" id="naturalidade" v-model="formData.naturalidade" />

                <span style="color: red" v-for="error in v$.naturalidade.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- FILIAÇÃO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="conjuge_profissao">Filiação (Nome COMPLETO da mãe e Nome COMPLETO do pai)</label>
                <input style="text-transform: uppercase" class="form-control" id="filiacao" v-model="formData.filiacao" />

                <span style="color: red" v-for="error in v$.filiacao.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- SEXO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="sexo">Sexo</label>

                <select class="custom-select rounded-0" id="sexo" v-model="formData.sexo">
                  <option value="Feminino">FEMININO</option>
                  <option value="Masculino">MASCULINO</option>
                </select>

                <span style="color: red" v-for="error in v$.sexo.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ESTADO CIVIL -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="estado_civil">Estado civil</label>

                <select style="text-transform: uppercase" class="custom-select rounded-0" id="estado_civil" v-model="formData.estado_civil">
                  <option value="casado">Casado</option>

                  <option value="divorciado">Divorciado</option>
                  <option value="separado_judicialmente">Separado judicialmente</option>
                  <option value="solteiro_com_uniao_estavel">Solteiro com união estável</option>
                  <option value="solteiro_sem_uniao_estavel">Solteiro sem união estável</option>
                  <option value="viuvo">Viúvo</option>
                </select>

                <span style="color: red" v-for="error in v$.estado_civil.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ENDERECO CEP -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="endereco_cep">CEP</label>

                <div class="input-group">
                  <InputMask id="basic" class="form-control" v-model="formData.endereco_cep" placeholder="_______-___" mask="99999-999" />

                  <span class="input-group-append">
                    <button @click="buscarCep()" type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button>
                  </span>
                </div>

                <span style="color: red" v-for="error in v$.endereco_cep.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ENDERECO LOGRADOURO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="endereco">Logradouro</label>
                <input style="text-transform: uppercase" class="form-control" id="endereco" v-model="formData.endereco" />

                <span style="color: red" v-for="error in v$.endereco.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ENDERECO NÚMERO -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="endereco_num">Número</label>
                <input style="text-transform: uppercase" class="form-control" id="endereco_num" v-model="formData.endereco_num" />

                <span style="color: red" v-for="error in v$.endereco_num.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ENDERECO COMPLEMENTO -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="endereco_complemento">Complemento</label>
                <input style="text-transform: uppercase" class="form-control" id="endereco_complemento" v-model="formData.endereco_complemento" />
              </div>
            </div>

            <!-- ENDERECO BAIRRO -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="endereco_bairro">Bairro</label>
                <input style="text-transform: uppercase" class="form-control" id="endereco_bairro" v-model="formData.endereco_bairro" />

                <span style="color: red" v-for="error in v$.endereco_bairro.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ENDERECO CIDADE -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="endereco_cidade">Cidade</label>
                <input style="text-transform: uppercase" class="form-control" id="endereco_cidade" v-model="formData.endereco_cidade" />

                <span style="color: red" v-for="error in v$.endereco_cidade.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ENDERECO ESTADO -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="endereco_estado">Estado</label>
                <input style="text-transform: uppercase" class="form-control" id="endereco_estado" v-model="formData.endereco_estado" />

                <span style="color: red" v-for="error in v$.endereco_estado.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- FONE -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="fone">Telefone fixo</label>
                <!-- <InputMask placeholder="(__)_____-____" id="basic" class="form-control" v-model="formData.fone" mask="(99)99999-9999" /> -->

                <input class="form-control" v-model="formData.fone" />

                <span v-if="formData.fone" style="color: red" v-for="error in v$.fone.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- CELULAR -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="Celular">
                  Celular (com DDD)
                  <span style="color: red; margin-left: 5px">*Será enviado um SMS para validar</span>
                </label>

                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <img width="60px" height="37px" src="https://rochaleiloes.com.br/dist/img/Brazil_flag_300.png" />
                  </div>
                  <InputMask id="basic" class="form-control" v-model="formData.celular" placeholder="(__)_____-____" mask="(99)99999-9999" />
                </div>

                <span style="color: red" v-for="error in errors.telefone_celular" :key="error">
                  {{ error }}
                </span>

                <span style="color: red" v-for="error in v$.celular.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- PROFISSAO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="profissao">Profissão</label>
                <input style="text-transform: uppercase" class="form-control" id="profissao" v-model="formData.profissao" />

                <span style="color: red" v-for="error in v$.profissao.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- DADOS DO CÔNJUGE -->
        <div class="card-header" v-if="formData.estado_civil == 'casado' || formData.estado_civil == 'solteiro_com_uniao_estavel'">
          <h3 class="card-title" style="color: white">Dados do cônjuge</h3>
        </div>
        <div class="card-body" v-if="formData.estado_civil == 'casado' || formData.estado_civil == 'solteiro_com_uniao_estavel'">
          <div class="row">
            <!-- NOME COMPLETO -->
            <div class="col-sm-9">
              <div class="form-group">
                <label for="conjuge_nome_completo">Nome completo (Cônjuge)</label>
                <input style="text-transform: uppercase" class="form-control" id="conjuge_nome_completo" v-model="formData.conjuge_nome_completo" />

                <span style="color: red" v-for="error in v$.conjuge_nome_completo.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- CPF -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="conjuge_cpf">CPF (Cônjuge)</label>

                <InputMask id="basic" class="form-control" v-model="formData.conjuge_cpf" placeholder="___.___.___-__" mask="999.999.999-99" />

                <span style="color: red" v-for="error in v$.conjuge_cpf.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- RG -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="conjuge_rg">RG (Cônjuge)</label>
                <input class="form-control" id="conjuge_rg" v-model="formData.conjuge_rg" style="text-transform: uppercase" />

                <span style="color: red" v-for="error in v$.conjuge_rg.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ORGÃO EXPEDIDOR -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="conjuge_orgao_expedidor">Orgão expedidor (Cônjuge)</label>

                <input class="form-control" id="orgao_expedidor" v-model="formData.conjuge_orgao_expedidor" style="text-transform: uppercase" />

                <span style="color: red" v-for="error in v$.conjuge_orgao_expedidor.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- DATA EMISSÃO RG -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="conjuge_data_emissao_rg">Data emissão RG (Cônjuge)</label>

                <InputMask
                  id="basic"
                  class="form-control"
                  v-model="formData.conjuge_data_emissao_rg"
                  placeholder="__/__/____"
                  mask="99/99/9999"
                  slotChar="__/__/____"
                />

                <span style="color: red" v-for="error in v$.conjuge_data_emissao_rg.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- DATA NASCIMENTO-->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="conjuge_data_emissao_rg">Data de nascimento (Cônjuge)</label>

                <InputMask
                  id="basic"
                  class="form-control"
                  v-model="formData.conjuge_data_nascimento"
                  placeholder="__/__/____"
                  mask="99/99/9999"
                  slotChar="__/__/____"
                />

                <span style="color: red" v-for="error in v$.conjuge_data_nascimento.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- NACIONALIDADE -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="conjuge_nacionalidade">Nacionalidade (Cônjuge)</label>

                <input style="text-transform: uppercase" class="form-control" id="conjuge_nacionalidade" v-model="formData.conjuge_nacionalidade" />

                <span style="color: red" v-for="error in v$.conjuge_nacionalidade.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- NATURALIDADE -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="conjuge_naturalidade">Naturalidade (Cônjuge) (Cidade/Estado)</label>

                <input
                  style="text-transform: uppercase"
                  type="text"
                  class="form-control"
                  id="conjuge_naturalidade"
                  v-model="formData.conjuge_naturalidade"
                />

                <span style="color: red" v-for="error in v$.conjuge_naturalidade.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- FILIAÇÃO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="conjuge_filiacao">Filiação (Cônjuge) (Nome COMPLETO da mãe e Nome COMPLETO do pai)</label>
                <input style="text-transform: uppercase" class="form-control" id="conjuge_filiacao" v-model="formData.conjuge_filiacao" />

                <span style="color: red" v-for="error in v$.conjuge_filiacao.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- SEXO -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="conjuge_sexo">Sexo (Cônjuge)</label>

                <select class="custom-select rounded-0" id="conjuge_sexo" v-model="formData.conjuge_sexo">
                  <option value="Feminino">FEMININO</option>
                  <option value="Masculino">MASCULINO</option>
                </select>

                <span style="color: red" v-for="error in v$.conjuge_sexo.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- PROFISSAO -->
            <div class="col-sm-9">
              <div class="form-group">
                <label for="conjuge_profissao">Profissão (Cônjuge)</label>
                <input style="text-transform: uppercase" class="form-control" id="conjuge_profissao" v-model="formData.conjuge_profissao" />

                <span style="color: red" v-for="error in v$.conjuge_profissao.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- DATA CASAMENTO
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label for="conjuge_data_casamento">Data de casamento</label>

                                <InputMask id="basic" class="form-control" v-model="formData.data_casamento"
                                    placeholder="__/__/____" mask="99/99/9999" slotChar="__/__/____" />

                                <span style="color: red" v-for="error in v$.data_casamento.$errors" :key="error.$uid">
                                    {{ error.$message }}
                                </span>
                            </div>
                        </div>
                        -->

            <!-- REGIME CASAMENTO -->
            <div class="col-sm-12">
              <div class="form-group">
                <label for="regime_casamento">Regime do casamento</label>
                <select class="custom-select rounded-0" id="regime_casamento" v-model="formData.regime_casamento" style="text-transform: uppercase">
                  <option value="cpb">Comunhão parcial de bens</option>
                  <option value="cub">Comunhão universal de bens</option>
                  <option value="outros">Outros</option>
                  <option value="pfa">Participação final nos aquestos</option>
                  <option value="seb">Separação de bens</option>
                </select>

                <span style="color: red" v-for="error in v$.regime_casamento.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <button type="submit" class="btn btn-primary" @click="enviar()">Cadastrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Loading from "vue-loading-overlay";
import InputMask from "primevue/inputmask";

import useVueLidate from "@vuelidate/core";
import { email, sameAs, helpers } from "@vuelidate/validators";
import { required, minLength, maxLength } from "../locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  mixins: [sweetAlert, Swal],

  props: ["orgaos_expedidores_rg", "paises", "magistrado"],

  components: { Loading, InputMask },

  setup() {
    const formData = reactive({
      fone: "",
      celular: "",
      filiacao: "",
      cadastro_tipo: "pf",
      nome_completo: "",
      conjuge_cpf: "",
      conjuge_rg: "",
      conjuge_orgao_expedidor: "",
      conjuge_data_emissao_rg: "",
      conjuge_naturalidade: "",
      conjuge_nacionalidade: "",
      conjuge_data_nascimento: "",
      conjuge_sexo: "",
      conjuge_profissao: "",
      conjuge_filiacao: "",
      cpf: "",
      rg: "",
      orgao_expedidor: "",
      data_emissao_rg: "",
      naturalidade: "",
      nacionalidade: "",
      data_nascimento: "",
      sexo: "",
      estado_civil: "",
      endereco_cep: "",
      endereco_num: "",
      endereco_complemento: "",
      endereco_bairro: "",
      endereco: "",
      endereco_estado: "",
      endereco_estado_id: "",
      endereco_cidade: "",
      endereco_cidade_id: "",
      data_casamento: "",
      regime_casamento: "",
    });

    const rules = computed(() => {
      let local_rules = {
        filiacao: { required },
        fone: { maxLength: maxLength(20) },
        celular: { required, minLength: minLength(11) },
        cadastro_tipo: { required },
        nome_completo: { required },
        orgao_expedidor: { required },
        cpf: { required, validarCPF: helpers.withMessage(" Digite um CPF válido.", validarCPF) },
        rg: { required },
        data_emissao_rg: {
          required,
          validDate: helpers.withMessage(" Digite uma data válida.", validDate),
          minDate: helpers.withMessage(" A data não pode ser maior que hoje.", minDate),
        },
        naturalidade: { required },
        nacionalidade: { required },
        data_nascimento: {
          required,
          validDate: helpers.withMessage(" Digite uma data válida.", validDate),
          minDate: helpers.withMessage(" A data não pode ser maior que hoje.", minDate),
        },
        sexo: { required },
        estado_civil: { required },
        endereco_cep: { required },
        endereco_cidade: { required },
        endereco_estado: { required },
        endereco: { required },
        endereco_bairro: { required },
        endereco_num: { required },
        profissao: { required },
      };

      if (formData.estado_civil == "casado" || formData.estado_civil == "uniao_estavel" || formData.estado_civil == "solteiro_com_uniao_estavel") {
        local_rules.conjuge_nome_completo = {
          required,
        };
        local_rules.conjuge_orgao_expedidor = {
          required,
        };
        local_rules.conjuge_cpf = {
          required,
          checkCFPConjuge: helpers.withMessage(" CPF do usuário e do cônjuge não podem ser iguais.", checkCFPConjuge),
          validarCPF: helpers.withMessage(" Digite um CPF válido.", validarCPF),
        };
        local_rules.conjuge_rg = {
          required,
          validarRG: helpers.withMessage(" RG do usuário e do cônjuge não podem ser iguais.", validarRG),
        };
        local_rules.conjuge_data_emissao_rg = {
          required,
          validDate: helpers.withMessage(" Digite uma data válida.", validDate),
          minDate: helpers.withMessage(" A data não pode ser maior que hoje.", minDate),
        };
        local_rules.conjuge_data_nascimento = {
          required,
          validDate: helpers.withMessage(" Digite uma data válida.", validDate),
          minDate: helpers.withMessage(" A data não pode ser maior que hoje.", minDate),
        };
        local_rules.conjuge_naturalidade = {
          required,
        };
        local_rules.conjuge_nacionalidade = {
          required,
        };
        local_rules.conjuge_sexo = {
          required,
        };
        local_rules.conjuge_profissao = {
          required,
        };
        local_rules.conjuge_filiacao = {
          required,
        };
        local_rules.regime_casamento = {
          required,
        };
      }

      return local_rules;
    });

    const validDate = (value) => {
      return moment(value, "DD/MM/yyyy").format("yyyy-MM-DD") != "Invalid date";
    };

    const checkCFPConjuge = (cpf) => {
      return cpf != formData.cpf;
    };

    const validarRG = (rg) => {
      let rg_comparacao = "";
      let rg_informado = rg.toUpperCase().replace(/[^\w\s]/gi, "");

      if (formData.rg) {
        rg_comparacao = formData.rg.toUpperCase().replace(/[^\w\s]/gi, "");
      }

      return rg_informado != rg_comparacao;
    };

    //DATA MENOR QUE HOJE
    const minDate = (date) => {
      if (moment(date, "DD/MM/yyyy").format("yyyy-MM-DD") != "Invalid date") {
        let data = new Date(moment(date, "DD/MM/yyyy"));

        return data < new Date();
      } else {
        return true;
      }
    };

    const minBirthDate = (date) => {
      return new Date(date) >= new Date("01-01-1940");
    };

    const validaConjuge = (estado_civil, sibling) => {
      console.log("SIB");
      console.log(sibling.estado_civil);
      if (sibling.estado_civil && sibling.estado_civil == "casado") {
        console.log("Entrou no if");
        return true;
      } else {
        console.log("Entrou no else");
        return false;
      }
    };

    const validarCPF = (cpf) => {
      cpf = cpf.replace(/\D/g, "");
      if (cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) return false;
      var result = true;
      [9, 10].forEach(function (j) {
        var soma = 0,
          r;
        cpf
          .split(/(?=)/)
          .splice(0, j)
          .forEach(function (e, i) {
            soma += parseInt(e) * (j + 2 - (i + 1));
          });
        r = soma % 11;
        r = r < 2 ? 0 : 11 - r;
        if (r != cpf.substring(j, j + 1)) result = false;
      });
      return result;
    };

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  data() {
    return {
      isLoading: false,
      termos: false,
      cep_valido: false,
      campos_endereco_bloqueados: true,
      cidade_valida: false,
      estado_valido: false,
      errors: [],
    };
  },

  mounted() {
    this.errors = {
      telefone_celular: [],
      total: 0,
    };
  },

  methods: {
    validateCelular() {
      if (this.formData.celular) {
        let data = {
          telefone_celular: this.formData.celular.replace(/[^Z0-9]/g, ""),
        };

        console.log("Enviando");
        console.log(data);

        axios
          .post("/user/cadastro/validate_celular", data)
          .then((response) => {
            console.log(response.data);

            if (response.data.success) {
              this.errors.telefone_celular = [];
            } else {
              this.errors.telefone_celular = ["Celular inválido ou já cadastrado!"];
            }
          })
          .catch((error) => {
            console.log(error);

            return false;
          });
      }
    },

    validateCPF() {
      if (this.formData.cpf) {
        let data = {
          cpf: this.formData.cpf.replace(/[^Z0-9]/g, ""),
        };

        axios
          .post("/user/cadastro/validate_cpf", data)
          .then((response) => {
            console.log(response.data);

            if (response.data.success) {
              this.errors.cpf = [];
            } else {
              this.errors.cpf = ["CPF inválido ou já cadastrado!"];
            }
          })
          .catch((error) => {
            console.log(error);

            return false;
          });
      }
    },

    redirect() {
      window.location.href = "/user";
    },

    buscarCep() {
      this.isLoading = true;
      this.cep_valido = false;

      let cep = this.formData.endereco_cep.replace(/[^Z0-9]/g, "");

      this.getCep(cep);

      /*
            axios
                .post(process.env.MIX_VUE_APP_VALIDAR_CEP + `/search`, data)
                .then((response) => {

                    this.isLoading = false;

                    console.log(response.data);

                    if (response.data.status == "OK" && !response.data.dados.erro) {

                        let dados = response.data.dados;

                        console.log(dados);

                        this.buscarCidade(dados);

                        this.formData.endereco = dados.logradouro;
                        this.formData.endereco_bairro = dados.bairro;
                        this.formData.endereco_cidade = dados.localidade;

                        this.cep_valido = true;

                    } else {

                        let mensagem = response.data.mensagem;

                        if (!response.data.mensagem) {
                            mensagem = "Digite um cep válido!"
                        }

                        this.showErrorMessageWithButton("Ops...", mensagem);
                        this.cep_valido = false;
                    }

                })
                .catch((error) => {
                    this.isLoading = false;

                    this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                    console.log(error.response.data);
                });*/
    },

    getCep(cep) {
      axios
        .get("https://viacep.com.br/ws/" + cep + "/json/")
        .then((response) => {
          let dados = response.data;

          console.log(dados);

          this.buscarCidade(dados);

          this.formData.endereco = dados.logradouro;
          this.formData.endereco_bairro = dados.bairro;
          this.formData.endereco_cidade = dados.localidade;

          this.cep_valido = true;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);

          if (error.response && error.response.status == 400) {
            this.showErrorMessageWithButton("Ops...", "Digite um cep válido!");
            this.cep_valido = false;
            this.isLoading = false;
          } else {
            this.showErrorMessageWithButton("Ops...", "Cep inválido.");
            this.cep_valido = false;
            this.isLoading = false;
          }
        });
    },

    buscarCidade(dados) {
      let data = {
        nome: dados.localidade,
        estado_sigla: dados.uf,
      };

      console.log(data);

      axios
        .post(`/user/cidade/buscar`, data)
        .then((response) => {
          if (response.data.success) {
            this.formData.endereco_cidade = response.data.cidade.nome;
            this.formData.endereco_cidade_id = response.data.cidade.id;

            this.formData.endereco_estado = response.data.estado.nome;
            this.formData.endereco_estado_id = response.data.estado.id;
          } else {
            this.formData.cidade = response.data.cidade = "";
            this.formData.estado = response.data.estado = "";

            this.formData.endereco_estado = "";
            this.formData.endereco_estado_id = "";
          }

          console.log(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    buscarCidadePorNome(callback) {
      if (this.formData.endereco_estado_id != null && this.formData.endereco_cidade) {
        let data = {
          nome: this.formData.endereco_cidade,
          estado_id: this.formData.endereco_estado_id,
        };

        console.log(data);

        axios
          .post(`/user/endereco/cidade_por_nome`, data)
          .then((response) => {
            if (response.data.cidade) {
              this.formData.endereco_cidade = response.data.cidade.nome;
              this.formData.endereco_cidade_id = response.data.cidade.id;
            } else {
              this.formData.endereco_cidade_id = null;
            }

            callback();
          })
          .catch((error) => {
            this.showErrorMessageWithButton("Ops..", error);
            console.log(error);
          });
      } else {
        this.formData.endereco_cidade_id = null;
        callback();
      }
    },

    buscarEstadoPorNome(callback) {
      let data = {
        nome: this.formData.endereco_estado.toUpperCase(),
      };

      console.log(data);

      axios
        .post(`/user/endereco/estado_por_nome`, data)
        .then((response) => {
          console.log("Resposta estado");
          console.log(response.data);

          if (response.data.estado) {
            this.formData.endereco_estado = response.data.estado.nome;
            this.formData.endereco_estado_id = response.data.estado.id;
          } else {
            this.formData.endereco_estado_id = null;
          }

          callback();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    async enviar() {
      const result = await this.v$.$validate();

      //CALCULAR TOTAL ERROS
      let keys = Object.keys(this.errors);
      let total = 0;

      for (let i = 0; i < keys.length; i++) {
        if (this.errors[keys[i]] && this.errors[keys[i]].length && this.errors[keys[i]].length != 0) {
          total++;
        }
      }

      this.errors.total = total;

      this.buscarEstadoPorNome(() => {
        this.buscarCidadePorNome(() => {
          if (this.formData.endereco_estado_id == null) {
            this.showErrorMessageWithButton("Ops...", "Confira o  nome do estado");
          } else if (this.formData.endereco_cidade_id == null) {
            this.showErrorMessageWithButton("Ops...", "Confira o nome da cidade");
          } else if (result && this.errors.total == 0) {
            this.create();
          }
        });
      });
    },

    formatDateToSave(date) {
      return moment(date, "DD/MM/yyyy").format("yyyy-MM-DD");
    },

    async create() {
      this.isLoading = true;

      let data = {
        fone: this.formData.fone.replace(/[^Z0-9]/g, ""),
        celular: this.formData.celular.replace(/[^Z0-9]/g, ""),
        cadastro_tipo: this.formData.cadastro_tipo,
        nome: this.formData.nome_completo.toUpperCase(),
        cpf: this.formData.cpf.replace(/[^Z0-9]/g, ""),
        rg: this.formData.rg.toUpperCase(),
        orgao_expedidor_id: this.formData.orgao_expedidor,
        data_emissao_rg: this.formatDateToSave(this.formData.data_emissao_rg),
        naturalidade: this.formData.naturalidade.toUpperCase(),
        nacionalidade: this.formData.nacionalidade.toUpperCase(),
        filiacao: this.formData.filiacao.toUpperCase(),
        sexo: this.formData.sexo,
        estado_civil: this.formData.estado_civil,
        endereco_cep: this.formData.endereco_cep,
        endereco_num: this.formData.endereco_num.toUpperCase(),
        endereco_complemento: this.formData.endereco_complemento.toUpperCase(),
        endereco: this.formData.endereco.toUpperCase(),
        endereco_bairro: this.formData.endereco_bairro.toUpperCase(),
        estado_id: this.formData.endereco_estado_id,
        cidade_id: this.formData.endereco_cidade_id,
        data_nascimento: this.formatDateToSave(this.formData.data_nascimento),
        data_casamento: this.formatDateToSave(this.formData.data_casamento),
        regime_casamento: this.formData.regime_casamento,
        profissao: this.formData.profissao.toUpperCase(),
        magistrado: this.magistrado ? 1 : 0,
      };

      if (
        this.formData.estado_civil == "casado" ||
        this.formData.estado_civil == "uniao_estavel" ||
        this.formData.estado_civil == "solteiro_com_uniao_estavel"
      ) {
        data.conjuge_nome = this.formData.conjuge_nome_completo.toUpperCase();
        data.conjuge_cpf = this.formData.conjuge_cpf.replace(/[^Z0-9]/g, "");
        data.conjuge_data_nascimento = this.formatDateToSave(this.formData.conjuge_data_nascimento);
        data.conjuge_rg = this.formData.conjuge_rg.toUpperCase();
        data.conjuge_orgao_expedidor_id = this.formData.conjuge_orgao_expedidor;
        data.conjuge_data_emissao_rg = this.formatDateToSave(this.formData.conjuge_data_emissao_rg);
        data.conjuge_naturalidade = this.formData.conjuge_naturalidade.toUpperCase();
        data.conjuge_nacionalidade = this.formData.conjuge_nacionalidade.toUpperCase();
        data.conjuge_sexo = this.formData.conjuge_sexo;
        data.conjuge_profissao = this.formData.conjuge_profissao.toUpperCase();
        data.conjuge_filiacao = this.formData.conjuge_filiacao.toUpperCase();
      }

      console.log("CRIANDO");
      console.log(data);

      axios
        .post(`/user/profile/complete`, data)
        .then((response) => {
          if (response.data.success) {
            this.showSuccessMessage("Cadastro enviado!");

            window.location.href = "/user";
          } else {
            this.showErrorMessageWithButton("Ops..", response.data.msg);
            this.isLoading = false;
          }
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButton("Ops..", "Algo deu errado!");
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.card-outline:hover {
  background-color: #428bca;
  cursor: pointer;
}

.inner {
  background-color: white;
}

label,
h3,
input {
  color: black;
}
</style>
